import useGetPointsHistories from './useGetPointsHistories'

export default useGetPointsHistories
